<template>
  <Table.Base :auto-columns="false">
    <Table.Headers>
      <Table.Header class="tablet-h:pl-[18px]">
        All Dacr Public Files
      </Table.Header>
      <Table.Header class="hidden tablet-h:block w-1/2!">
        Dacr Timestamp
      </Table.Header>
    </Table.Headers>
    <Table.Row
      v-for="file in props.files"
      :key="file.id"
      @click="handleFileClick(file)"
    >
      <Table.Cell class="tablet-h:pl-[18px]">
        <ThumbnailIcon
          class="mr-2.5 min-w-9 max-w-9 h-9 tablet-h:min-w-6 tablet-h:max-w-6 tablet-h:h-6"
          :icon-size="iconSize"
          :type="file.type"
          :image-url="
            applyAuthorizationToken(file.imageUrl, [
              {
                key: 'width',
                value: 72,
              },
            ])
          "
        />
        <div
          v-truncate
          class="w-full font-secondary text-[14px] text-gray-800 leading-[18px]"
        >
          <div data-truncate-target>
            {{ file.name }}
          </div>
          <div
            class="w-fit tablet-h:hidden flex items-center text-[13px] opacity-50"
          >
            <Icon :size="14" name="Dacr" class="fill-gray-800 mr-1" />
            <div class="mt-[1px]">
              {{ formatTimestamp(file.timestamp) }}
            </div>
          </div>
        </div>
      </Table.Cell>
      <Table.Cell class="w-1/2! hidden tablet-h:flex items-center">
        <Icon :size="18" name="Dacr" class="fill-gray-800 mr-2" />
        <div>
          {{ formatTimestamp(file.timestamp) }}
        </div>
      </Table.Cell>
    </Table.Row>
  </Table.Base>

  <div
    v-if="files?.length"
    class="flex items-center h-[40px] pl-2.5 tablet-h:pl-[18px]"
    @click="handleClose"
  >
    <RouterLink :to="`/search/public?query=${props.query}`">
      <Link>View all results in Dacr public files</Link>
    </RouterLink>
  </div>

  <div
    v-else
    class="flex items-center h-[64px] tablet-h:h-[40px] pl-2.5 tablet-h:pl-[18px] border-b tablet-h:border-none border-gray-800/8 font-secondary text-[14px] leading-[18px] text-gray-800/50"
  >
    No public files match your search
  </div>
</template>

<script setup lang="ts">
import { ThumbnailIcon, Table, Icon } from '@dacr/ui'
import { type SearchFile } from '@/shared/graphql/legacy/generated'
import { useDevice } from '@/shared/composables/useDevice'
import { useRouter } from 'vue-router'
import { computed } from 'vue'
import { applyAuthorizationToken } from '@/shared/utils/url'
import { formatTimestamp } from '@/shared/utils/datetime'
import Link from '@/shared/components/Link.vue'

const props = defineProps<{
  files?: SearchFile[]
  query: string
}>()

const emit = defineEmits<{
  (e: 'close'): void
}>()

const device = useDevice()
const router = useRouter()

const iconSize = computed(() => (device.isMobile.value ? 36 : 24))

const handleFileClick = (file: SearchFile) => {
  router.push(`/file/${file.id}`)
  handleClose()
}

const handleClose = () => {
  emit('close')
}
</script>
